var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "vds-dspark",
      style: {
        height: "".concat(_vm.height, "px")
      },
      attrs: {
        role: "presentation",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 ".concat(_vm.W, " ").concat(_vm.height),
            preserveAspectRatio: "none"
          }
        },
        [
          _c("path", {
            staticClass: "vds-dspark__fill",
            attrs: {
              d: _vm.areaPath(_vm.pointsA),
              fill: _vm.colorA
            }
          }),
          _c("path", {
            attrs: {
              d: _vm.linePath(_vm.pointsA),
              stroke: _vm.colorA,
              "stroke-width": _vm.lineWidth,
              fill: "none",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "vector-effect": "non-scaling-stroke"
            }
          }),
          _c("path", {
            attrs: {
              d: _vm.linePath(_vm.pointsB),
              stroke: _vm.colorB,
              "stroke-width": _vm.lineWidth,
              fill: "none",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "vector-effect": "non-scaling-stroke"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }